import React, {useEffect} from 'react'
import AlunosView from "./AlunosView";
import {useDispatch} from "react-redux";
import {getDOF, getEstruturaLevelDisciplinas} from '../../store/actions/estruturaDiscActions';

export interface iAlunoBase {
    id?: number,
    Name?: string,
    email?: string,
    MobileNumber?: string,
    PhoneNumber?: string,
    Mother?: string,
    Father?: string,
    BirthDate?: string
    BithPlace?: string,
    
    
}


interface  iAlunos {

}

const Alunos = ( props : iAlunos  ) => {
    const dispatch = useDispatch();
    
    useEffect(() => {
       dispatch(getDOF());
        dispatch(getEstruturaLevelDisciplinas());
       
    }, []);

    return (
        <React.Fragment>
            <AlunosView />
        </React.Fragment>
    )
}

export default  (Alunos);

